/**
 * This guard is used to prevent logged in user for accessing guest routes.
 * Ex: Logged in user can't access login screen.
 */
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';

@Injectable({ providedIn: 'root' })
export class GuestGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      // Let LTI/Edlink relaunch callbacks through so the login component can
      // update the ltiContext in localStorage before routing to home.
      if (route.queryParams['edlink'] === 'success') {
        return true;
      }
      this.router.navigate(['/home']);
      return false;
    }
    return true;
  }
}
